<template>
  <div class="container">
    <!-- 关于我们 -->
    <div class="vue">
      <!-- 关于我们 -->
      <div class="aboutUs">
        <div class="headline FontW6 textA-C primaryCol">关于我们</div>
        <el-row>
          <el-col class="about-data " :span="14" :offset="5">
            <div class="data-head flex">
              <el-image
                :src="require('@/assets/image/webImage/about/gsjj.jpg')"
              ></el-image>
              <div class="aboutUs-right">
                <div class="name primaryCol FontW6">公司简介</div>
                <div class="name-cont">
                  {{ aboutUs.intro }}
                </div>
                <div class="Core">
                  <span class="primaryCol FontW6">核心</span>
                  <span class="Core-cont">{{ aboutUs.core }}</span>
                </div>
                <div class="slogan">
                  <span class="primaryCol FontW6">口号</span>
                  <span class="slogan-cont">{{ aboutUs.slogan }}</span>
                </div>
              </div>
            </div>
            <div class="purpose flex">
              <div class="purpose-left">
                <div class="name primaryCol FontW6">宗旨</div>
                <div class="name-cont">{{ aboutUs.purpose }}</div>
                <div class="name primaryCol FontW6">使命</div>
                <div class="name-cont">{{ aboutUs.mission }}</div>
                <div class="name primaryCol FontW6">愿景</div>
                <div class="name-cont">{{ aboutUs.vision }}</div>
              </div>
              <el-image
                :src="require('@/assets/image/webImage/about/zz.jpg')"
              ></el-image>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 养老-背景介绍 -->
      <div class="Pension">
        <div class="Pension-bg">
          <el-image
            class="img-bg"
            :src="require('@/assets/image/webImage/about/gywm_bg.jpg')"
          ></el-image>
          <el-row class="Pension-row">
            <el-col
              class="Pension-data whiteCol flex flexJc-sb"
              :span="14"
              :offset="5"
            >
              <div
                class="Pension-list  flex flexAi-c flexJc-c "
                v-for="(item, index) in inPensionlist"
                :key="index"
              >
                <div class="img flex  flexAi-c">
                  <el-image :src="item.img"></el-image>
                  <div class="img-name primaryCol">{{ item.name }}</div>
                </div>
                <div class="list-cont">
                  {{ item.note }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 居家养老 -->
      <div class="home-based">
        <el-row>
          <el-col class="living " :span="14" :offset="5">
            <div class="title padVertical15 FontW6">居家养老</div>
            <div class="living-data flex flexJc-sb">
              <div
                class="living-list flex flexAi-fs"
                v-for="(item, index) in livingList"
                :key="index"
              >
                <div class="img">
                  <el-image :src="item.img"></el-image>
                </div>
                <div class="list-contant">
                  <div class="list-contant-title padVertical10 FontW6">
                    {{ item.name }}
                  </div>
                  <span class="spanCol">{{ item.note }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 发展历程 -->
      <div class="development">
        <el-row>
          <el-col class="development-cont " :span="14" :offset="5">
            <div class="headline flex flexJc-sb flexAi-c">
              <div class="title-img flex flexAi-c">
                <el-image
                  :src="require('@/assets/image/webImage/fzlc.png')"
                ></el-image>
                <span class="title FontW8 padHorizontal10">发展历程</span>
              </div>
              <div class="but">
                <el-button class="FontW6" @click="leftBut">←</el-button>
                <el-button class="FontW6" @click="rightBut">→</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="xian">
          <el-image
            :src="require('@/assets/image/webImage/biaochi.png')"
          ></el-image>
        </div>
        <el-row>
          <el-col class="swiper-col " :span="14" :offset="5">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide flex flexAi-c"
                  v-for="(item, index) in swiperList"
                  :key="index"
                >
                  <!-- <div class="timeline"></div>
                  <div class="timeline"></div> -->
                  <div class="headline-data FontW6 padVertical10">
                    {{ item.name }}
                  </div>
                  <div class="triangle"></div>
                  <div class="card">
                    <el-image :src="item.thumbnail" fit="scale-down"></el-image>
                    <div class="swiper-data ">
                      <span class="spanCol">{{ item.text | getText }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { apiPageHome } from '@/api/webViews'
let mySwiper

export default {
  name: '',
  props: [''],
  data() {
    return {
      activities: [
        {
          content: '支持使用图标',
          timestamp: '2018-04-12 20:46',
          size: 'large',
          type: 'primary',
          icon: 'el-icon-more'
        },
        {
          content: '支持自定义颜色',
          timestamp: '2018-04-03 20:46',
          color: '#0bbd87'
        },
        {
          content: '支持自定义尺寸',
          timestamp: '2018-04-03 20:46',
          size: 'large'
        },
        {
          content: '默认样式的节点',
          timestamp: '2018-04-03 20:46'
        }
      ],
      inPensionlist: [
        {
          name: '智慧养老',
          img: require('@/assets/image/webImage/about/zhyl2.png'),
          note:
            '老人如出现紧急情况时，能通过“键式”呼叫发出呼救信息，老人监护人能及时与老人进行联系。同时老人也可直接呼叫服务平台...'
        },
        {
          name: '居家养老',
          img: require('@/assets/image/webImage/about/jjyl2.png'),

          note:
            '以家庭为核心、以社区为依托、以专业化服务为依靠，为居住在家的老年人提供以解决日常生活困难为主要内容的社会化服务。'
        },
        {
          name: '社区养老',
          img: require('@/assets/image/webImage/about/sqyl2.png'),

          note:
            '举办养老、敬老、托老福利机构;设立老人购物中心和服务中心:开设老人餐桌和老人食堂:建立老年医疗保健机构;建立老年活动中心:设立老年婚介..'
        },
        {
          name: '机构养老',
          img: require('@/assets/image/webImage/about/jgyl2.png'),

          note:
            '把专业的医疗技术检查和先进设备与康复训练、日常学习、日常饮食、生活养老等专业相融合。以医疗为保障，以康复为支撑，边医边养、综合治疗。'
        }
      ],
      livingList: [
        {
          name: '健康监控',
          note:
            '建立连续详实的健康档案，通过数据跟踪比对，结合自身健康状况提出合理的保健建议，切实预防疾病隐患。',
          img: require('@/assets/image/webImage/service/jkjc.png')
        },
        {
          name: '医护定制',
          note:
            '根据客户的身体状况需求及家庭条件制定个性化服务；对不方便或不愿意去医院就诊的，提供专业的医护人员上门进行服务。',
          img: require('@/assets/image/webImage/service/yhdz.png')
        },
        {
          name: '照料护理',
          note:
            '根据个人的身体状况和家庭需求，帮助提供相应的照料服务，让用户得到悉心照料。',
          img: require('@/assets/image/webImage/service/zlhl.png')
        },
        {
          name: '心理关爱',
          note:
            '根据用户的心理健康和实际需求，开展多种形式的心理疏导，帮助用户缓解心理压力、放下思想包袱。',
          img: require('@/assets/image/webImage/service/xlga.png')
        },
        {
          name: '康复理疗',
          note:
            '引进康复的专业医护人员，借助康复设备，给予康复措施和护理服务;提供中医推拿、经络按摩、拔罐、刮痧、灸疗等服务。',
          img: require('@/assets/image/webImage/service/kfll.png')
        },
        {
          name: '陪同就医',
          note:
            '可以通过App或者电话进行预约服务。1.预约挂号，缩短等待时间；2.疾病分诊咨询，初步选择就诊科室；3.陪同就医；4.专车接送。',
          img: require('@/assets/image/webImage/service/ptjy.png')
        },
        {
          name: '家政服务',
          note:
            '根据用户家政的需求，提供擦拭门框窗框、物品分类归位、家具除尘、沙发地毯除尘、墙体地面除尘除垢、家用电器表面清洁、厨卫台表面擦拭的清洁。',
          img: require('@/assets/image/webImage/service/jzfw.png')
        },
        {
          name: '就餐助餐',
          note:
            '聘用营养师，进行合理的配餐，给老人提供最健康的饭菜（三公里内可进行配送）。',
          img: require('@/assets/image/webImage/service/jczc.png')
        }
      ],
      swiperList: [
        {
          img: require('@/assets/image/webImage/lt.png'),
          note: 'sdhjkljdklsj 多久是多久啊肯德基打开链接阿三哭了多久啊弹尽粮绝'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡记得看手机',
          title: '服务自渡',
          note: 'sdhjkljdklsj 多久是多久啊肯德基打开链接阿三哭了多久啊弹尽粮绝'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡记得看手机',
          title: '服务自渡',
          note: 'sdhjkljdklsj 多久是多久啊肯德基打开链接阿三哭了多久啊弹尽粮绝'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡记得看手机',
          title: '服务自渡',
          note: 'sdhjkljdklsj 多久是多久啊肯德基打开链接阿三哭了多久啊弹尽粮绝'
        }
      ],
      aboutUs: {
        intro:
          '无锡零忧托居家养老服务有限公司是一家提供精心精细精准的居家医疗护理服务公司，是无锡市长期护理保险定点服务机构。公司自主研发了“零忧托APP”平台，采取“ 互联网+物联网+养老”的服务模式满足老年人及其家庭健康需求。囊括了健康监测、陪同就医、医护定制、照料护理、康复理疗、就餐助餐、家政服务、心理关爱、能力评估、适老产品等服务内容。自201 6年组建以来服务覆盖几+余社区、六千余老人，致力于为政府社会和老年群体之间架起“暖心桥梁"，为老年人的生活质量和身心健康提供可靠保障。',
        core: '以人为本、变革创新、协作共享',
        slogan: '居家养老零忧托，呵护健康幸福多',
        purpose: '把养老产业当做事业去追求，把敬老使命当做生命去呵护。',
        mission:
          '为政府分忧，替子女尽孝，让长者居家养老生活更便捷、更智能、更健康、更幸福。',
        vision:
          '打造没有围墙的养老院，为亿万老人的健康生活，提供专业优质、高效便捷、互联互通的一站式智慧养老服务。'
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.PageHome()
  },

  methods: {
    // 加载轮播图
    Swiper() {
      mySwiper = new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination'
        },
        slidesPerView: 4 // 页面分组显示，这里显示为3组
      })
    },
    // 轮播图向左
    leftBut() {
      mySwiper.slidePrev()
    },
    // 轮播图向右
    rightBut() {
      mySwiper.slideNext()
    },
    /* 接口 */
    // 首页
    PageHome() {
      apiPageHome().then(res => {
        if (res.status === '0') {
          this.swiperList = res.data.aboutUs
          setTimeout(() => {
            this.Swiper()
          }, 500)
        }
        console.log(this.majorList)
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  .aboutUs {
    .headline {
      height: 30px;
      font-size: 26px;
      padding: 25px 0;
    }
    .about-data {
      .data-head {
        .el-image {
          width: 50%;
        }
        .aboutUs-right {
          width: 50%;
          padding-left: 30px;
          line-height: 25px;
          .name {
            padding-bottom: 10px;
            font-size: 16px;
          }
          .Core,
          .slogan {
            .Core-cont,
            .slogan-cont {
              padding-left: 10px;
            }
          }
        }
      }
      .purpose {
        padding: 20px 0;
        line-height: 25px;
        .purpose-left {
          padding-right: 30px;
        }
        .el-image {
          height: 200px;
        }
      }
    }
  }
  .Pension {
    padding: 20px 0;
    .Pension-bg {
      position: relative;

      .img-bg {
        height: 364px;
      }
      .Pension-row {
        top: 0;
        z-index: 2;
        position: absolute;
      }
      .Pension-data {
        height: 364px;
        .Pension-list {
          padding-right: 30px;
          flex-direction: column;
          .img {
            flex-direction: column;
            padding: 15px;
            padding-bottom: 10px;
            border-radius: 20%;
            background: #fff;
            .img-name {
              padding-top: 5px;
            }
          }
          .list-cont {
            padding-top: 20px;
          }
        }
        .Pension-list:last-child {
          padding-right: 0;
        }
      }
    }
  }
  .home-based {
    padding-bottom: 15px;
    .living {
      .title {
        font-size: 26px;
        border-bottom: 3px solid #e0e0e0;
      }
      .living-data {
        flex-wrap: wrap;
        .living-list {
          margin: 20px 10px;
          border: 1px solid #e0e0e0;
          // flex-direction: column;
          width: 20%;
          .img {
            background: #fff;
            position: relative;
            left: -30px;
            top: 10px;

            .el-image {
              width: 40px;
              height: 40px;
              padding: 10px;
              border-radius: 50%;
              border: 2px solid #f0f0f0;
            }
          }
          .list-contant {
            padding-bottom: 10px;
            position: relative;
            left: -15px;
            .list-contant-title {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .development {
    background: #f2f2f2;
    .development-cont {
      .headline {
        padding: 40px 0;
        .title-img {
          .title {
            font-size: 26px;
            color: #7d7d7d;
          }
        }
      }
    }
    .xian {
      position: relative;
      top: -20px;
      width: 100%;
      // height: 3px;
      // background: #cfcfcf;
    }
    .swiper-col {
      top: -25px;
      position: relative;
      .swiper-container {
        .swiper-slide {
          flex-direction: column;
          .timeline {
            top: -2px;
            width: 14px;
            height: 14px;
            background-color: #cfcfcf;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .headline-data {
            font-size: 18px;
          }
          .triangle {
            position: relative;
            top: -20px;
            width: 0;
            height: 0;
            border: 10px solid;
            border-color: transparent transparent #fff;
          }
          .card {
            position: relative;
            top: -20px;
            margin: 0 20px;
            padding: 12px;
            background: #fff;
            .swiper-data {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
              overflow: hidden;
              color: #8a8687;
            }
          }
        }
      }
    }
  }
}
</style>
